<template>
	<b-card title="Text" class="mb-3">
		<b-form-row>
			<b-col cols="6">
				<div class="form-group">
					<div class="float-right"><b-form-checkbox size="sm" v-model="settings.customFont">Custom</b-form-checkbox></div>
					<label for="fontFamilyInput">Font family</label>
					<VueTypeaheadBootstrap
						v-model="settings.fontFamily"
						:data="settings.customFont ? [] : googleFonts"
						:serializer="item => `${item.family}`"
						placeholder="Search fonts..."
						disable-sort
						autocomplete="off"
						required
						id="fontFamilyInput"
					/>
				</div>
			</b-col>
			<b-col>
				<b-form-group label="Font size" append="px">
					<b-input-group append="px">
						<b-form-input type="number" min="0" max="999" step="any" v-model="settings.fontSize"></b-form-input>
					</b-input-group>
				</b-form-group>
			</b-col>
			<b-col>
				<b-form-group label="Letter spacing">
					<b-input-group append="px">
						<b-form-input type="number" min="0" max="999" step="any" v-model="settings.letterSpacing"></b-form-input>
					</b-input-group>
				</b-form-group>
			</b-col>
		</b-form-row>
		<b-form-row>
			<b-col cols="5" v-if="!noAlign">
				<b-form-group label="Align">
					<b-button-group class="d-flex w-100">
						<b-button v-b-tooltip.hover.bottom title="Align left" :pressed="settings.textAlign == 'left'" @click="settings.textAlign = 'left'" variant="outline-secondary">
							<b-icon icon="text-left" aria-hidden="true"></b-icon>
						</b-button>
						<b-button v-b-tooltip.hover.bottom title="Align center" :pressed="settings.textAlign == 'center'" @click="settings.textAlign = 'center'" variant="outline-secondary">
							<b-icon icon="text-center" aria-hidden="true"></b-icon>
						</b-button>
						<b-button v-b-tooltip.hover.bottom title="Align right" :pressed="settings.textAlign == 'right'" @click="settings.textAlign = 'right'" variant="outline-secondary">
							<b-icon icon="text-right" aria-hidden="true"></b-icon>
						</b-button>
					</b-button-group>
				</b-form-group>
			</b-col>
			<b-col cols="7">
				<b-form-group label="Formatting">
					<b-button-group class="d-flex w-100">
						<b-button v-b-tooltip.hover.bottom title="Bold" :pressed="settings.boldText" @click="settings.boldText = !settings.boldText" variant="outline-secondary">
							<b-icon icon="type-bold" aria-hidden="true"></b-icon>
						</b-button>
						<b-button v-b-tooltip.hover.bottom title="Italic" :pressed="settings.italicText" @click="settings.italicText = !settings.italicText" variant="outline-secondary">
							<b-icon icon="type-italic" aria-hidden="true"></b-icon>
						</b-button>
						<b-button v-b-tooltip.hover.bottom title="Underline" :pressed="settings.underlineText" @click="settings.underlineText = !settings.underlineText" variant="outline-secondary">
							<b-icon icon="type-underline" aria-hidden="true"></b-icon>
						</b-button>
						<b-button v-b-tooltip.hover.bottom title="Strikethrough" :pressed="settings.strikethroughText" @click="settings.strikethroughText = !settings.strikethroughText" variant="outline-secondary">
							<b-icon icon="type-strikethrough" aria-hidden="true"></b-icon>
						</b-button>
						<b-button v-b-tooltip.hover.bottom title="Uppercase" :pressed="settings.uppercaseText" @click="settings.uppercaseText = !settings.uppercaseText" variant="outline-secondary">
							<b-icon icon="align-top" aria-hidden="true"></b-icon>
						</b-button>
					</b-button-group>
				</b-form-group>
			</b-col>
		</b-form-row>
	</b-card>
</template>

<script>
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
export default {
	props: {
		settings: Object,
		noAlign: Boolean,
	},
	data() { return {
		googleFonts: [],
	}},
	components: {
		VueTypeaheadBootstrap,
	},
	async mounted() {
		this.googleFonts = await this.$api.get('googleFonts');
	},
};
</script>
